"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _initMode = require("../initMode");

var _extractValuesForProps = _interopRequireDefault(require("../utils/extractValuesForProps"));

var _PrepareValidationError = _interopRequireDefault(require("../PrepareValidationError"));

var _initComponent = _interopRequireDefault(require("./initComponent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Action that prepares a single component. Duplicate calls with exactly the same
 * `Component` and `props` will be ignored.
 *
 * @param {react.Component} Component The component to prepare. If the component was not
 * wrapped in `withInitAction`, this action will have no effect and returns a Promise that
 * resolves immediately.
 * @param {object} [props={}] The values of `initProps` to initialize this component with. These
 * values should be the same as the props that the component will eventually mount with. Omitting
 * one of the `initProps` values configured in `withInitAction()` will result in an error.
 * @returns {function} A thunk function that should be passed directly to the Redux `dispatch`
 * function.
 * @example dispatch(prepareComponent(Comment, { commentId: 5 }));
 */
var _default = function _default(Component) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (dispatch, getState) {
    // unwrap other HoC if no initConfig is found
    while (!Component.initConfig && Component.WrappedComponent) {
      Component = Component.WrappedComponent; // eslint-disable-line no-param-reassign
    }

    if (Component.initConfig) {
      var _Component$initConfig = Component.initConfig,
          componentId = _Component$initConfig.componentId,
          initProps = _Component$initConfig.initProps,
          _Component$initConfig2 = _Component$initConfig.options,
          getInitState = _Component$initConfig2.getInitState,
          getPrepareKey = _Component$initConfig2.getPrepareKey;
      var initState = getInitState(getState());

      if (!initState) {
        throw new ReferenceError('Could not find init state. Did you attach the init reducer?');
      }

      var mode = initState.mode;

      if (mode === _initMode.MODE_PREPARE) {
        var initValues = (0, _extractValuesForProps.default)(props, initProps);
        initValues.forEach(function (initValue, index) {
          if (typeof initValue === 'undefined') {
            throw new _PrepareValidationError.default("Component \"".concat(componentId, "\" expected prop \"").concat(initProps[index], "\" but no value was passed to prepareComponent()"), 'prepare-component-expected-prop', {
              initProps: JSON.stringify(initProps),
              Component: componentId,
              propName: initProps[index]
            });
          }
        });
        var prepareKey = getPrepareKey(componentId, initValues);
        return dispatch((0, _initComponent.default)(Component, initValues, prepareKey, {
          caller: 'prepareComponent'
        }));
      }
    }

    return Promise.resolve();
  };
};

exports.default = _default;